
 // ★获取插件数据
function getSelectedLbAddons() {
  return $('.lb-widget-pal lb-upsell-flat-card[lb-selected]').map(function () {
    const $card = $(this)

    return {
      productId: $card.attr('lb-product-id'),
      variantId: $card.find('.lb-variant-picker').val() || $card.attr('lb-variant-id'),
      num: $card.find(".lb-qty-count")?.val() || 1
    }
  }).get()
}
function mainRender() {
     var $numDom=$("#calcNumber")

    $(function () {
        $('#root').css('zoom', 'normal')
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)

        window.addEventListener(
            'resize',
            (function () {
                var timer
                return function () {
                    if (timer) clearTimeout(timer)
                    timer = setTimeout(function () {
                        $('#root').css('zoom', 'normal')
                        let scale = document.body.clientWidth / 1080
                        $('#root').css('zoom', scale)
                    }, 100)
                }
            })()
        )
        // 倒计时
        // 生成随机时间
        function generateRandomTime() {
            var hours = Math.floor(Math.random() * 15) + 1
            var minutes = Math.floor(Math.random() * 60)
            var seconds = Math.floor(Math.random() * 60)
            //总共的毫秒数
            var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

            return targetTime
        }
        function TimeDown(value) {
            //倒计时的总秒数
            var totalSeconds = parseInt(value / 1000)
            //取模（余数）
            var modulo = totalSeconds % (60 * 60 * 24)
            //小时数
            var hours = Math.floor(modulo / (60 * 60))
            modulo = modulo % (60 * 60)
            //分钟
            var minutes = Math.floor(modulo / 60)
            //秒
            var seconds = modulo % 60

            hours = hours.toString().length == 1 ? '0' + hours : hours
            minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
            seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

            //输出到页面
            $('.sp_hour').html(hours)
            $('.sp_minute').html(minutes)
            $('.sp_second').html(seconds)
            //延迟一秒执行自己
            if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
            } else {
                setTimeout(function () {
                    TimeDown(value - 1000)
                }, 1000)
            }
        }
        TimeDown(generateRandomTime())
        let sp_price1 = 17.99
        let sp_price2 = 35.99

        function calcTotal(price, num) {
            let _result = Number(price) * Number(num)
            return _result.toFixed(0)
        }
        let prods = window.product
        function getCur() {
            let color = $('#color div.active').attr('data-val')
            let size = $('#Size div.active').attr('data-val')
            let antal = $('#antal div.active').attr('data-val')
            return prods.filter(
                item =>
                    item.option1 == color 
                && item.option2 == size
                && item.option3 == antal
            )[0]
        }
        function changePrice() {
            let num = $('#calcNumber').val()
            let price = ((getCur().price * num) / 100).toFixed(0)
            let compare = ((getCur().compare_at_price * num) / 100).toFixed(0)
            price = (price + '').replace('.', ',')
            compare = (compare + '').replace('.', ',')
            $('#new').html(price)
            $('#old').html(compare)
            let off_font =
                100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
            //   $(".product-part .sp-frees .sp-off").html(off_font);
        }
        $('.sp-btn-style').click(function () {
            let num = $('#calcNumber').val()
            let id = getCur().id;
    
    const items = [
        {
        id,
        num
     },...(getSelectedLbAddons().length ? (getSelectedLbAddons().map(item => ({
        id: item.variantId,
        num:item.num}))) : [])
]
    // window.location.href = "/cart/" + id + ":" + num;
   window.location.href = '/cart/' + items.map(item => {
  return item.id + ':' + item.num
}).join(',')
        })
        var main_id = ''
        $('.emitCheckout').click(function () {
            console.log('1111')
            main_id = getCur().id
            // main_id = $(this).siblings('.select_span').find('span.on').data('id')
            // window.location.href = "/cart/" + id + ":1"
        })

        function getPopProdId() {
            let selectVals = []
            $('.overbuy_wrap .sp-subopt.active').each(function () {
                selectVals.push($(this).data('val'))
            })

            let cur = popProduct.filter(item => {
                let option1 = selectVals[0]
                let option2 = null
                let option3 = null
                if (selectVals[1]) {
                    option2 = selectVals[1]
                }
                if (selectVals[2]) {
                    option3 = selectVals[2]
                }

                return (
                    item.option1 == option1 &&
                    item.option2 == option2 &&
                    item.option3 == option3
                )
            })

            return cur[0]
        }

        $('.overbuy-select div').click(function () {
            $(this).siblings().removeClass('active')
            $(this).addClass('active')
            let cur = getPopProdId()

            if (cur) {
                $('.main-btn').text('KRIJG 10% KORTING').removeClass('overbuy_disabled')
                let _price = parseFloat(cur.price / 100).toFixed(0)
                let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(
                    2
                )

                $('.overbuy_price span .price1').html(_price)
                $('.overbuy_price span .price2').html(_compare_at_price)
            } else {
                $('.main-btn').text('Unavailable').addClass('overbuy_disabled')
            }
        })

        window.emitSubmit = function (_type) {
            let num = $('#calcNumber').val()

            if (_type == 'all') {
                // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
                let _id = getPopProdId()?.id
                if (!_id) return
                console.log(_id)

                window.location.href = `/cart/${main_id}:${num},${_id}:1`
            } else {
                window.location.href = `/cart/${main_id}:${num}`
            }
        }

        // 弹窗 end
        // 数字框
        $('.reduce').click(function () {
            let input = $(this).siblings('input')[0]
            let num = Number(input.value) - 1
            if (num > 0) {
                input.value = num
            }
            changePrice()
        })
        $('.add').click(function () {
            let input = $(this).siblings('input')[0]
            let num = Number(input.value) + 1
            input.value = num
            changePrice()
        })
        // style选项
        let typeOptions = $('#color .option')
        var imgArr = [
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-1.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-2.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-3.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-4.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-5.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-6.png',
        ]
        var imgArr2 = [
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/97_2.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/spp_shopify20250930112803_38fc38e4eea1087310226b90680b82ab_4111bde4-7d75-43da-b60e-8f586fdf598f_2.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/41bc6dd2994b091e3eb738b115d87f32_4.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/97_4.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/spp_shopify20250930112803_38fc38e4eea1087310226b90680b82ab_4111bde4-7d75-43da-b60e-8f586fdf598f_4.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/41bc6dd2994b091e3eb738b115d87f32_7.png?v=1760336828',
        ]
        var imgArr3 = [
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJwYFcSdLTNvNAjnNA8ywzkpAIU8Jc_0IyMGkFO6kAQ_972_569.png?v=1760342341',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPKHdCIsdx_NvNAjnNA8ywhogLLuY_c_4IyMGkFO6kAg_972_569.png?v=1760342341',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJyFyvbj1zNvNAjnNA8ywhtFgiToWzlsIyMGkFO6kAA_972_569.png?v=1760342342',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJxv6HnyuYVvNAjnNA8ywiG9KaRHU0DMIyMGq_rMbAA_972_569.png?v=1760342341',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJw6obGdrEVvNAjnNA8yw-3S_4CsbA_kIyMGrAJmHAA_972_569.png?v=1760342342',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPKH5K72jGkVvNAjnNA8ywUqMEdHRAgocIyMGq_n6KAA_972_569.png?v=1760342343',
        ]

        var imgList=[
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-1.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-2.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-3.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-1.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-2.png',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/20251011-pro-3.png',

            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/97_2.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/spp_shopify20250930112803_38fc38e4eea1087310226b90680b82ab_4111bde4-7d75-43da-b60e-8f586fdf598f_2.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/41bc6dd2994b091e3eb738b115d87f32_4.png?v=1760336828',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/97_4.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/spp_shopify20250930112803_38fc38e4eea1087310226b90680b82ab_4111bde4-7d75-43da-b60e-8f586fdf598f_4.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/41bc6dd2994b091e3eb738b115d87f32_7.png?v=1783481579',

            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJwYFcSdLTNvNAjnNA8ywzkpAIU8Jc_0IyMGkFO6kAQ_972_569.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPKHdCIsdx_NvNAjnNA8ywhogLLuY_c_4IyMGkFO6kAg_972_569.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJyFyvbj1zNvNAjnNA8ywhtFgiToWzlsIyMGkFO6kAA_972_569.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJxv6HnyuYVvNAjnNA8ywiG9KaRHU0DMIyMGq_rMbAA_972_569.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPJw6obGdrEVvNAjnNA8yw-3S_4CsbA_kIyMGrAJmHAA_972_569.png?v=1783481578',
            'https://cdn.shopify.com/s/files/1/0729/8747/6117/files/lQLPKH5K72jGkVvNAjnNA8ywUqMEdHRAgocIyMGq_n6KAA_972_569.png?v=1783481578',
        ]
        typeOptions.click(function () {
            var index = $(this).index()
            var index2 = $('#Size .option.active').index()
            var index3 = $('#antal .option.active').index()
            $(this).addClass('active').siblings().removeClass('active')
            changeOption(index, index2,index3)
        })
        $('#antal .option').click(function () {
            var index = $('#color .option.active').index()
            var index2 = $('#Size .option.active').index()

            var index3 = $(this).index()
            $(this).addClass('active').siblings().removeClass('active')

            changeOption(index, index2,index3)
        })
        $('#Size .option').click(function () {
            var index = $('#color .option.active').index()
            var index3 = $('#antal .option.active').index()
            var index2 = $(this).index()
            $(this).addClass('active').siblings().removeClass('active')
            changeOption(index, index2,index3)
        })
        function changeOption(index, index2, index3) {
            changePrice()
            if (index2 == 1 && index3 == 0) {
                $('.top-text').show()
            } else {
                $('.top-text').hide()
            }
            let flag=index+index2*3+index3*6
            $('.top-product>img').attr('src', imgList[flag])
            // if (index2 == 0) {
            //     $('.top-product>img').attr('src', imgArr[index])
            // } else if (index2 == 1) {
            //     $('.top-product>img').attr('src', imgArr2[index])
            // } else if (index2 == 2) {
            //     $('.top-product>img').attr('src', imgArr3[index])
            // }
        }
        // style选项
        $('.cart-btn').click(function () {
            $(this).children('img').addClass('on')
            setTimeout(function () {
                $('.cart-btn').children('img').removeClass('on')
            }, 500)
            $('.sp-header-top .sp-cart').addClass('on')
            setTimeout(function () {
                $('.sp-header-top .sp-cart').removeClass('on')
            }, 500)
        })
        // 加入购物车
        addCart()
        function addCart() {
            // 加入购物车
            $('.addCerts').click(function () {
                // do something here
                // var number =
                //   Number($('.sp-cart #cardNum').html()) + Number($('#calcNumber').val())
                // $('.sp-cart #cardNum').html(number)
                // if (number > 0) {
                //   $('.sp-cart .num').css('background', '#cf0101')
                // } else {
                //   $('.sp-cart .num').css('background', '#919191')
                // }
                // ★加购data更换
  const itemsData = [
                {
              id: (typeof getCur !== 'undefined' ? getCur().id : 'mock-id') ,
              quantity: $('#calcNumber').val(),
            },
            ...(getSelectedLbAddons().length ? (getSelectedLbAddons().map(item => ({id: item.variantId,quantity:item.num}))) : [])
            ];
                // var data = {
                //     id: getCur().id,
                //     quantity: $('#calcNumber').val(),
                // }
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                     // data: data,
                    // ★★★更换数据
                    data: {
                        items:itemsData
                    },
                    success: function () {
                        $.getJSON(
                            window.Shopify.routes.root + 'cart.js',
                            function (result) {
                                $('#cardNum').html(result.item_count)
                                if (result.item_count > 0) {
                                    $('.sp-cart .num').css('background', '#cf0101')
                                } else {
                                    $('.sp-cart .num').css('background', '#919191')
                                }
                            }
                        )
                    },
                    dataType: 'json',
                })
                var img = $('.top-product img')
                var flyer = img[0].cloneNode(true)
                flyer.classList.add('clone')
                $('.product-part').append(flyer)
                $('.clone').css({
                    width: img.width(),
                    height: img.height(),
                    position: 'fixed',
                    top: img[0].offsetTop,
                    left: img.offset().left,
                    'z-index': '99',
                })
                var offset = $('.sp-cart')[0].getBoundingClientRect()
                $('.sp-cart').addClass('shake')
                setTimeout(() => {
                    $('.sp-cart').removeClass('shake')
                }, 1000)
                let finish = $('.sp-cart')
                $('.clone').animate(
                    {
                        top: finish[0].offsetTop + 117,
                        left: finish[0].offsetLeft + finish.width() / 2 - 15,
                        width: 50, // 结束时的大小，根据需要调整
                        height: 50, // 结束时的大小，根据需要调整
                        opacity: 0.4,
                    },
                    1000,
                    'linear',
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach() // 完成动画后移除克隆的图片
                            }
                        )
                    }
                )
            })
        }
        // 文字标题动画
        const graduallyList = document.getElementsByClassName('gradually')
        for (let gradually of graduallyList) {
            const spans = gradually.querySelectorAll('span'),
                paragraph = gradually.querySelector('.sp-sub-title'),
                observer = new IntersectionObserver(
                    entries => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                spans.forEach((span, index) => {
                                    ; (span.style.animation = 'swift-up-fade 0.5s ease forwards'),
                                        (span.style.animationDelay = `${index * 0.15}s`)
                                    const i = span.querySelector('i')
                                    i &&
                                        ((i.style.animation = 'swift-up-fade 0.5s ease forwards'),
                                            (i.style.animationDelay = `${index * 0.15}s`))
                                })
                                const totalDelay = spans.length * 0.15 + 0.3
                                paragraph &&
                                    ((paragraph.style.animation =
                                        'swift-up-fade 0.5s ease forwards'),
                                        (paragraph.style.animationDelay = `${totalDelay}s`)),
                                    observer.unobserve(gradually)
                            }
                        })
                    },
                    { threshold: 0.3 }
                )
            observer.observe(gradually)
        }
    })
    // 问答
    $('.q-row').click(function () {
        $(this).parent().toggleClass('sp-show')
    })
    function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
        const config = {
            rootMargin: '0px 0px 1300px 0px',
            threshold: 0,
        }

        const lazyLoadObserver = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 当图片进入视口时
                    const image = entry.target
                    const dataSrc = image.getAttribute('data-src')
                    image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                    lazyLoadObserver.unobserve(image) // 停止观察该图片
                }
            })
        },
            config)

        images.forEach(function (image) {
            lazyLoadObserver.observe(image) // 开始观察每个图片
        })
    }

    function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
            // 处理二维数组
            imageArray.forEach(subArray => {
                subArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            })
        } else {
            // 处理一维数组
            imageArray.forEach(url => {
                const img = new Image()
                img.src = url
            })
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        lazyLoadImages()

        // preloadImages(imagesOneDim)
        // preloadImages(imagesTwoDim)

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop =
                    targetElement.offsetTop -
                    $('.sp-header-top').height() -
                    $('.time-part').height()
                window.scroll({
                    top: offsetTop * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
        console.log('Android')
    } else if (isIOS) {
        console.log('iOS')
    } else if (isPC) {
        console.log('PC')
    } else {
        $('.sp_system').css('letter-spacing', '-4px')
    }
}

mainRender()
